/**
 * The value line for an employee multi-select (CheckPicker renderValue):
 * "All Employees" when everyone is picked, the names when one or two are,
 * otherwise the first two and how many more.
 */
export const renderEmployeeSelection = (options) => (value) => {
  const picked = options.filter((option) => value.includes(option.value));
  if (picked.length === 0) return null;
  if (options.length > 1 && picked.length === options.length) return 'All Employees';
  if (picked.length <= 2) return picked.map((option) => option.label).join(', ');
  return `${picked[0].label}, ${picked[1].label}, +${picked.length - 2} more`;
};
